import { Link } from 'react-router-dom';
import caseStudies from '../data/caseStudies';

function CaseStudy({ study, index }) {
  return (
    <article className="case" id={study.id}>
      <div className="case-head">
        <p className="eyebrow">{study.client}</p>
        <h2 className="case-title">{study.title}</h2>
        <p className="case-tagline">{study.tagline}</p>
        {study.url &&
          (study.href ? (
            <a
              className="case-url"
              href={study.href}
              target="_blank"
              rel="noreferrer noopener"
            >
              {study.url}
            </a>
          ) : (
            <p className="case-url case-url--static">{study.url}</p>
          ))}
      </div>

      <div className="case-body">
        <div className="case-figure case-figure--hero">
          <img
            src={study.hero.src}
            alt={study.hero.alt}
            width={study.hero.width}
            height={study.hero.height}
            loading="lazy"
          />
        </div>

        <div className="case-detail">
          <p className="case-summary">{study.summary}</p>

          <ul className="module-chips">
            {study.modules.map((m) => (
              <li key={m} className="module-chip">{m}</li>
            ))}
          </ul>

          <ol className="case-points">
            {study.points.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ol>
        </div>
      </div>

      {study.metrics.length > 0 && (
        <div className="case-metrics">
          {study.metrics.map((m) => (
            <div className="case-metric" key={m.label}>
              <span className="case-metric-value">{m.value}</span>
              <span className="case-metric-label">{m.label}</span>
            </div>
          ))}
        </div>
      )}

      <div className="case-media">
        {study.media.map((m) => (
          <figure className="case-figure" key={m.src}>
            <img
              src={m.src}
              alt={m.alt}
              width={m.width}
              height={m.height}
              loading="lazy"
            />
            <figcaption>{m.caption}</figcaption>
          </figure>
        ))}
      </div>

      {index < caseStudies.length - 1 && <hr className="case-rule" />}
    </article>
  );
}

function Work() {
  return (
    <div className="work-page">
      <section className="hero hero--compact">
        <div className="hero-content">
          <h1 className="hero-title">Our Work</h1>
          <p className="hero-subtitle">
            Three programs, three different problems: booking and payments,
            multi-activation festivals, and measuring a whole show floor as one
            journey.
          </p>
        </div>
      </section>

      <section className="work-section">
        <div className="container">
          {caseStudies.map((study, i) => (
            <CaseStudy key={study.id} study={study} index={i} />
          ))}
        </div>
      </section>

      <section className="cta-band">
        <div className="container">
          <h2>Have an activation coming up?</h2>
          <p>
            Tell us what you're planning and we'll show you how we'd capture it.
          </p>
          <Link to="/contact" className="cta-button">Start a conversation</Link>
        </div>
      </section>
    </div>
  );
}

export default Work;
